import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams } from 'ionic-angular';
import {IntroChooseInsurranceCompanyPage} from "../intro-choose-insurrance-company/intro-choose-insurrance-company";
import {UserStateProvider} from "../../providers/user-state/user-state";
import {IntroWizardServiceProvider} from "../../providers/intro-wizard-service/intro-wizard-service";
import {AppRegistrationYubleSelectionPage} from "../app-registration-yuble-selection/app-registration-yuble-selection";

/**
 * Generated class for the AppRegistrationStartPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'page-app-registration-start',
  templateUrl: 'app-registration-start.html',
})
export class AppRegistrationStartPage {

  constructor(public navCtrl: NavController, public navParams: NavParams, public stateProvider: UserStateProvider, public introWizard: IntroWizardServiceProvider) {
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad AppRegistrationStartPage');
    this.introWizard.firstName = this.stateProvider.user.firstName;
  }


  goNext() {
    this.navCtrl.push(AppRegistrationYubleSelectionPage);
  }
}



// WEBPACK FOOTER //
// ./src/pages/app-registration-start/app-registration-start.ts